import { SiteFooter, SiteHeader, SponsorSlot } from "../_components/SiteChrome";
import { DeviceDownload } from "./DeviceDownload";

export default function DownloadsPage() {
  return (
    <>
      <SiteHeader />
      <main className="download-page">
        <section className="download-hero">
          <div className="hero-grid" aria-hidden="true" />
          <div className="shell download-hero-inner">
            <a className="back-link" href="/">← Back to GeoStream</a>
            <div className="status-pill"><span /> Public beta release</div>
            <h1>Download GeoStream Beta</h1>
            <p>Choose the installer made for your computer. Public packages will appear here only after signing, integrity, and clean-install testing are complete.</p>
          </div>
        </section>

        <section className="section download-options">
          <div className="shell">
            <div className="release-notice">
              <div><span className="notice-icon">i</span><div><strong>GeoStream shows only a verified installer.</strong><p>The signed and notarized macOS beta is available now. Windows will activate here after its separate signing and clean-install verification are complete.</p></div></div>
              <span>Beta channel · v0.1.x</span>
            </div>

            <DeviceDownload />

            <SponsorSlot compact eyebrow="Future setup sponsorship" title="Recommended creator hardware" description="Reserved for a clearly disclosed camera, capture, audio, or connectivity sponsor verified with GeoStream—not a company owner or rotating ad network." />
          </div>
        </section>

        <section className="section install-section">
          <div className="shell">
            <div className="section-heading split-heading">
              <div><p className="eyebrow">Install guide</p><h2>From package to first preview.</h2></div>
              <p>Use the instructions for your platform, then run GeoStream’s built-in preflight before connecting a production stream key.</p>
            </div>
            <p className="install-detection-note">Installation steps are shown directly beneath the detected installer above, so users never need to choose between platform instructions.</p>
          </div>
        </section>

        <section className="section requirement-section">
          <div className="shell requirement-layout">
            <div className="requirement-main"><p className="eyebrow">Required for live output</p><h2>GeoStream uses FFmpeg for streaming and recording.</h2><p>The studio can open without FFmpeg, but streaming, recording, and highlight export require a compatible build with H.264, AAC, FLV, MP4, WebM, RTMP, and RTMPS support.</p><div className="requirement-steps"><span><b>1</b>Install a trusted FFmpeg build</span><span><b>2</b>Add its <code>bin</code> folder to PATH</span><span><b>3</b>Restart GeoStream</span><span><b>4</b>Run Preflight</span></div></div>
            <aside className="security-card"><span className="security-kicker">INSTALL SAFELY</span><h3>Verify before opening</h3><p>Every public package will include a SHA-256 digest. Compare it with your downloaded installer before running it.</p><code>Get-FileHash -Algorithm SHA256 .\GeoStream_*.exe</code><p className="security-note">Never include stream keys, account tokens, or private identifiers in a screenshot or bug report.</p></aside>
          </div>
        </section>

        <section className="section test-focus-section">
          <div className="shell">
            <div className="section-heading centered-heading"><p className="eyebrow">Beta test focus</p><h2>What we want testers to try.</h2><p>Start with throwaway stream keys and non-production destinations.</p></div>
            <div className="test-grid"><span>App launch and studio rendering</span><span>Multiple cameras and device switching</span><span>Screen and microphone permissions</span><span>Scenes, sources, and resizable panels</span><span>Connected-account validation</span><span>Guardian rehearsal and readiness</span><span>Landscape and portrait editions</span><span>Streaming and local recording</span></div>
          </div>
        </section>

        <section className="download-help"><div className="shell final-cta-inner"><div><p className="eyebrow">Before reporting a problem</p><h2>Keep the report useful and safe.</h2><p>Include Windows or macOS version, GeoStream version, what you clicked, and the exact error text. Remove credentials and private destination details.</p></div><a className="button button-secondary" href="/#faq">Read common questions</a></div></section>
      </main>
      <SiteFooter />
    </>
  );
}
